import ProductListConnector from './productList.props';
import ProductListComponent from './productList.component';

export default ProductListConnector(ProductListComponent);
